<template>
<div>
  <div class="flex flex-col justify-center items-center">
    <div v-if="!isSent" class="block p-10 w-full text-start max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
      <form @submit.prevent="handleContact">
        <h5 class="mb-2 text-center text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Contact Form</h5>

        <div class="mb-6">
          <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Select a reason</label>
          <select v-model="contactForm.categoryId" id="countries" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{category.name}}</option>
          </select>
        </div>
        <div v-if="contactForm.categoryId === 4 && loggedIn" class="mb-6">
          <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Select a receipt</label>
          <select v-model="contactForm.receiptId" id="countries" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required>
            <option v-for="receipt in userBillings.receipts" :key="receipt.id" :value="receipt.order_id">{{receipt.order_id}} - {{receipt.amount}}{{receipt.currency}}</option>
          </select>
          <p class="text-sm font-medium text-gray-900 dark:text-gray-400">- Refund requests are considered if they are in our <a href="/refunds">Refund Policy</a> scope. Before send the form, you may check it.</p>
        </div>
        <div class="mb-6">
          <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email(*)</label>
          <input v-model="contactForm.email" type="email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
        </div>
        <div class="mb-6">
          <label for="subject" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Subject(*)</label>
          <input v-model="contactForm.subject" type="text" id="text" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
        </div>
        <div class="mb-6">
          <label for="message" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your message(*)</label>
          <textarea v-model="contactForm.message" id="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Leave a message..."></textarea>
        </div>
        
        <div class="validationError mb-6">
          <span v-for="error in errors" :key="error" v-html="error" class="text-sm font-medium text-gray-900 dark:text-gray-400"></span>
        </div>
        <div class="mb-2 text-center">
          <button v-if="!loading" :disabled="loading" type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Send</button>
          <button v-else :disabled="loading" type="submit" class="opacity-50 cursor-auto w-full text-white bg-blue-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700">Send</button>
        </div>
      </form>
    </div>
    <div v-else class="block p-10 w-full text-start max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
      <br>
      <span>Your message has been sent. Tickets are being replied between 48-72 hours.</span>
      <br><br>
      <div class="mb-2 text-center">
          <button @click="goToHomePage" type="button" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Go To Home Page</button>
        </div>
    </div>
  </div>

  <!--<div class="login-page">
    <div class="form">
      <div class="login-header">Contact Form</div>
      <div v-if="!isSent">
        <div class="login-text">How can we help you?</div>
        <form name="form" class="login-form">
          <div>
            <v-select
              :items="categories"
              v-model="contactForm.categoryId"
              label="Select a Reason"
              item-text="name"
              item-value="id"
              solo
            ></v-select>
          </div>
          <div class="input-icons">
            <i class="fa fa-envelope icon"></i>
            <input :disabled="userEmail" type="text" class="input-field" placeholder="Enter your email" v-model="contactForm.email"/>
          </div>
          <div class="input-icons">
            <i class="fa fa-envelope icon"></i>
            <input type="text" class="input-field" placeholder="Enter your name(*)" v-model="contactForm.name"/>
          </div>
          <div class="input-icons">
            <i class="fa fa-envelope icon"></i>
            <input type="text" class="input-field" placeholder="Title(*)" v-model="contactForm.title"/>
          </div>
          <div>
            <v-textarea
              class="text-area"
              v-model="contactForm.content"
              label="Your Message...(*)"
              solo
            ></v-textarea>
          </div>
          <v-btn class="blue" @click="handleContact" :disabled="loading">{{submitText}}</v-btn>
        </form>
      </div>
      <div v-else>
        <br>
        <span>Your message has been sent. Tickets are being replied between 48-72 hours.</span>
        <br><br>
        <v-btn class="blue text" @click="goToHomePage">Go To Home Page</v-btn>
      </div>
    </div>
  </div>-->
  </div>
</template>

<script>
import HelpDeskService from '../services/helpdesk.service';
import SubscriptionService from '../services/subscription.service';

export default {
  name: 'Contact',
  data() {
    return {
      contactForm: {
        name: '',
        email: '',
        subject: '',
        content: '',
        categoryId: '',
        receiptId: ''
      },
      categories: [],
      loading: false,
      submitText: 'Submit',
      isSent: false,
      errors: []
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    
  },
  mounted() {
    if(this.loggedIn)
    {
      this.contactForm.email = this.$store.state.auth.user.email;
      this.getUserBillings();
    }else{
      this.getCategories();
    }
  },
  methods: {
    handleContact() {
      this.errors = [];
      if(this.contactForm.email === ''){
        this.errors.push("- Email must be given(*)<br>");
      }else if(!this.validEmail(this.contactForm.email)){
        this.errors.push("- Email must be valid(*)<br>");
      }
      if(this.contactForm.categoryId === ''){
        this.errors.push("- Reason must be given(*)<br>");
      }
      if(this.contactForm.subject === ''){
        this.errors.push("- Subject must be given(*)<br>");
      }
      if(this.contactForm.message === ''){
        this.errors.push("- Message must be given(*)<br>");
      }
      if(this.errors.length === 0)
      {
        this.loading = true;
        this.submitText = 'Submitting...';

        HelpDeskService.sendContactForm(this.contactForm).then(
          response => {
            if(response.data.response.success)
            {
              this.contactForm = {};
              this.isSent = true;
            }
            this.loading = false;
            this.submitText = 'Submit';
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
              this.loading = false;
              this.submitText = 'Submit';
          }
        );
      }
    },
    getCategories() {
      HelpDeskService.getCategories().then(
        response => {
          if(response.data.response.success)
          {
            var refund = null;
            var other = null;
            response.data.response.categories.forEach(element => {
              if(element.name !== 'Refund' && element.name !== 'Other')
              {
                this.categories.push({ id: element.id, name: element.name});
              }else if(element.name === 'Refund'){
                refund = element;
              }else if(element.name === 'Other'){
                other = element;
              }
            });

            if(refund !== null)
            {
              if(this.userBillings != null)
              {
                if(this.userBillings.receipts.length > 0)
                {
                  this.categories.push({ id: refund.id, name: refund.name});
                }
              }
            }

            if(other !== null)
            {
              this.categories.push({ id: other.id, name: other.name});
            }
          }
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },

  getUserBillings(){
    SubscriptionService.getUserBillings().then(
      response => {
        this.userBillings = response.data.response;

        this.getCategories();

        this.userBillingsList = JSON.stringify(this.userBillings);
        localStorage.setItem('userBillings', this.userBillingsList);
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
  },
  validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
	goToHomePage() {
      this.$router.push('/');
    },
  }
};
</script>

<style scoped>
.text-area {
  outline: 0;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
}

.input-icons i {
	position: absolute;
}
	
.input-icons {
	width: 100%;
	margin-bottom: 10px;
}
	
.icon {
	padding: 18px;
	color: #ababab;
	min-width: 50px;
	text-align: center;
}

.login-header{
	font-size: 24px;
	font-weight: bold;
}

.login-text{
	margin-bottom:30px;
	font-size: 14px;
	color:#666666;
}

.login-page {
  width: 600px;
  padding: 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 600px;
  margin: auto;
  padding: 45px;
  text-align: center;
  border: 1px solid #ebebeb;
  border-radius: 10px;
}
.form input {
  outline: 0;
  background: #ffffff;
  width: 100%;
  border: 1px solid #ebebeb;
  margin: 0 0 15px;
  padding: 15px 45px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 5px;
}
.form button {
font-weight: bold;
  outline: 0;
  background:rgb(55, 147, 233);
  width: 100%;
  border: 0;
  padding: 10px;
  color: #FFFFFF;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
  border-radius: 5px;
}
.form button:hover,.form button:active,.form button:focus {
  background: rgb(14, 125, 230);
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color:rgb(55, 147, 233);
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}
body {
  background: #76b852 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(right, #76b852, #8DC26F);
  background: -moz-linear-gradient(right, #76b852, #8DC26F);
  background: -o-linear-gradient(right, #76b852, #8DC26F);
  background: linear-gradient(to left, #76b852, #8DC26F);
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;      
}

</style>